export const fondueData = [
  {
    id: "moitie-moitie",
    name: "MOITIÉ-MOITIÉ",
    region: "Fribourg",
    badgeLabel: "FR",
    badgeColor: "#d71920",
    cheeses: ["Gruyère AOP", "Vacherin Fribourgeois AOP"],
    descriptionKey: "fondueMoitieDesc",
    ratios: [
      { cheese: "Gruyère AOP", percent: 50 },
      { cheese: "Vacherin Fribourgeois AOP", percent: 50 },
    ],
  },

  {
    id: "fribourgeoise",
    name: "FRIBOURGEOISE",
    region: "Fribourg",
    badgeLabel: "FR",
    badgeColor: "#d71920",
    cheeses: ["Vacherin Fribourgeois AOP"],
    descriptionKey: "fondueFribourgeoiseDesc",
    ratios: [{ cheese: "Vacherin Fribourgeois AOP", percent: 100 }],
  },

  {
    id: "neuchateloise",
    name: "NEUCHÂTELOISE",
    region: "Neuchâtel",
    badgeLabel: "NE",
    badgeColor: "#00843d",
    cheeses: ["Gruyère AOP", "Emmental AOP"],
    descriptionKey: "fondueNeuchateloiseDesc",
    ratios: [
      { cheese: "Gruyère AOP", percent: 60 },
      { cheese: "Emmental AOP", percent: 40 },
    ],
  },

  {
    id: "valaisanne",
    name: "VALAISANNE",
    region: "Valais",
    badgeLabel: "VS",
    badgeColor: "#e30613",
    cheeses: ["Raclette du Valais AOP", "Gruyère AOP"],
    descriptionKey: "fondueValaisanneDesc",
    ratios: [
      { cheese: "Raclette du Valais AOP", percent: 60 },
      { cheese: "Gruyère AOP", percent: 40 },
    ],
  },

  {
    id: "vaudoise",
    name: "VAUDOISE",
    region: "Vaud",
    badgeLabel: "VD",
    badgeColor: "#00843d",
    cheeses: ["Gruyère AOP", "Vacherin Fribourgeois AOP"],
    descriptionKey: "fondueVaudoiseDesc",
    ratios: [
      { cheese: "Gruyère AOP", percent: 60 },
      { cheese: "Vacherin Fribourgeois AOP", percent: 40 },
    ],
  },

  {
    id: "jura",
    name: "JURASSIENNE",
    region: "Jura",
    badgeLabel: "JU",
    badgeColor: "#d71920",
    cheeses: ["Gruyère AOP", "Tête de Moine AOP"],
    descriptionKey: "fondueJurassienneDesc",
    ratios: [
      { cheese: "Gruyère AOP", percent: 70 },
      { cheese: "Tête de Moine AOP", percent: 30 },
    ],
  },

  {
    id: "alpine",
    name: "ALPINE",
    region: "Alpes suisses",
    badgeLabel: "CH",
    badgeColor: "#b08a45",
    cheeses: ["Fromage d’alpage", "Gruyère AOP"],
    descriptionKey: "fondueAlpineDesc",
    ratios: [
      { cheese: "Fromage d’alpage", percent: 60 },
      { cheese: "Gruyère AOP", percent: 40 },
    ],
  },

  {
    id: "tessinoise",
    name: "TESSINOISE",
    region: "Tessin",
    badgeLabel: "TI",
    badgeColor: "#005baa",
    cheeses: ["Gruyère AOP", "Formaggio d’alpe ticinese"],
    descriptionKey: "fondueTessinoiseDesc",
    ratios: [
      { cheese: "Gruyère AOP", percent: 50 },
      { cheese: "Fromage tessinois", percent: 50 },
    ],
  },

  {
    id: "appenzelloise",
    name: "APPENZELLOISE",
    region: "Appenzell",
    badgeLabel: "AI",
    badgeColor: "#111111",
    cheeses: ["Appenzeller", "Gruyère AOP"],
    descriptionKey: "fondueAppenzellDesc",
    ratios: [
      { cheese: "Appenzeller", percent: 50 },
      { cheese: "Gruyère AOP", percent: 50 },
    ],
  },

  {
    id: "zurichoise",
    name: "ZURICHOISE",
    region: "Zurich",
    badgeLabel: "ZH",
    badgeColor: "#0072ce",
    cheeses: ["Gruyère AOP", "Emmental AOP", "Appenzeller"],
    descriptionKey: "fondueZurichDesc",
    ratios: [
      { cheese: "Gruyère AOP", percent: 50 },
      { cheese: "Emmental AOP", percent: 25 },
      { cheese: "Appenzeller", percent: 25 },
    ],
  },
];
